export default class GameCamera {
  constructor(game, scene) {
    this.game = game;
    this.scene = scene;
    this.target = null;
    this.isPanning = false;

    this.onPosition = new Phaser.Signal();
    this.onScroll = new Phaser.Signal();
  }

  setTarget(target) {
    this.target = target;
  }

  step(dt) {
    const maxSpeed = 150;
    if (this.isPanning) {
      // pan with limited speed
      if (this.currentX !== this.destX) {
        let dx = this.destX - this.currentX;
        const sg = dx < 0 ? -1 : 1;
        dx = Math.min(maxSpeed, Math.abs(dx)) * sg;
        this.currentX += dx * dt * 5;

        this.setCamera();

        if (Math.abs(this.destX - this.currentX) < 1) {
          this.currentX = this.destX;
          this.isPanning = false;
          this.onPosition.dispatch();
        }
      }
    } else {
      // normal movement
      if (this.target) {
        this.destX = this.target.getDestX();
      }

      // exception for non-scrolling screen
      if (this.scene.sceneWidth < 2000) {
        this.setPosition(872);
        this.onPosition.dispatch();
      }

      // move camera
      if (this.currentX !== this.destX) {
        let dx = this.destX - this.currentX;
        const sg = dx < 0 ? -1 : 1;
        dx = Math.min(maxSpeed, Math.abs(dx)) * sg;
        this.currentX += dx * dt * 5;

        this.setCamera();

        this.onScroll.dispatch();

        if (Math.abs(this.destX - this.currentX) < 1) {
          this.currentX = this.destX;
          this.onPosition.dispatch();
        }
      }
    }
  }

  setPosition(x) {
    this.destX = this.currentX = x;
    this.setCamera();
  }

  setCamera() {
    this.scene.x = this.game.width * 0.5 - this.currentX;
    this.checkBorders();
  }

  checkBorders() {
    // limit left side
    if (this.scene.x > 0) {
      this.scene.x = 0;

      this.currentX = this.game.width * 0.5;
      this.destX = this.currentX;
    }

    const sw = this.scene.sceneWidth; // > 0 ? this.scene.sceneWidth : this.game.width;

    // limit right side
    if (this.scene.x + sw < this.game.width) {
      this.scene.x = this.game.width - sw;

      this.currentX = this.game.width * 0.5 - this.scene.x;
      this.destX = this.currentX;
    }
  }

  pan(x) {
    this.destX = x;
    this.isPanning = true;
  }
}
